import _plugin_vue_export_helper_default from "../../_virtual/_plugin-vue_export-helper.js";
import ScalarFormSection_vue_vue_type_script_lang_default from "./ScalarFormSection.vue.script.js";
import { createElementBlock, createElementVNode, openBlock, renderSlot } from "vue";
//#region src/components/ScalarForm/ScalarFormSection.vue
var _hoisted_1 = { class: "flex min-w-0 flex-col gap-3" };
var _hoisted_2 = { class: "contents" };
var _hoisted_3 = { class: "text-base font-medium text-c-1" };
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
	return openBlock(), createElementBlock("fieldset", _hoisted_1, [createElementVNode("legend", _hoisted_2, [createElementVNode("span", _hoisted_3, [renderSlot(_ctx.$slots, "label")])]), renderSlot(_ctx.$slots, "default")]);
}
var ScalarFormSection_default = /*#__PURE__*/ _plugin_vue_export_helper_default(ScalarFormSection_vue_vue_type_script_lang_default, [["render", _sfc_render]]);
//#endregion
export { ScalarFormSection_default as default };

//# sourceMappingURL=ScalarFormSection.vue.js.map